import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EditableGridService, SystemApiService } from "@cv-invision/core";
import { Observable } from "rxjs";

@Injectable()
export class RelianceFirstService extends EditableGridService {

	constructor(
		private systemApiService: SystemApiService,
		private httpClient: HttpClient
	) {
		super();
	}

	/**
	 * Fetch data from the Reliance First orders API.
	 * @param params The query parameters to be sent with the HTTP GET request.
	 * @returns An Observable containing the response from the API.
	 */
	getData(params: any): Observable<any> {
		const url: string = `${this.systemApiService.api.relianceFirst}/orders`;
		return this.httpClient.get(url, { params });
	}

	/**
	 * GET - Return details of a specific order from the second endpoint.
	 */
	getOrderDetails(id: string): Observable<any> {
		return this.httpClient.get(`${this.systemApiService.api.relianceFirst}/order/${id}`);
	}
}